export const FETCH_CUSTOMER_PRINT_TEMPLATE = "FETCH_CUSTOMER_PRINT_TEMPLATE"
export const UPDATE_CUSTOMER_PRINT_TEMPLATE = "UPDATE_CUSTOMER_PRINT_TEMPLATE"